<template>
  <div class="d-flex align-items-stretch border-bottom">
    <div class="mr-3">
      <div
        class="d-flex align-items-center justify-content-center bg-orange h-100 square-order"
      >
        <span class="text-white h3 m-0" v-text="order" />
      </div>
    </div>
    <div class="w-100">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderedHeader',
  props: { order: { type: [Number, String], default: 0 } },
};
</script>

<style lang="scss" scoped>
.square-order {
  width: 34px;
  max-width: 34px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;

  @media (min-width: 768px) {
    width: 58px;
    max-width: 58px;
  }
}
</style>
